import { formatDate, formatTime, getTimestampFromDateTime, getCurrentDate } from '../../helpers/formatDate'
import { formatMoney, isDocumentCredit, parseDocumentType } from '../../helpers/utils'
import { parseRefundType } from './constants'

export const buildCsvFile = (data, canSeeAnnulledDocumentsTab = false, origin = "") => {
  let rows = []

  // ====== ENCABEZADO PRINCIPAL ======

  rows.push(['Reporte:', 'Liquidación'])
  rows.push(['Número de liquidación:', data?.uid || 'N/A'])
  rows.push(['Fecha de creación:', getTimestampFromDateTime(data?.collected_at) || 'N/A'])
  rows.push([''])

  rows.push(['Nombre de empresa:', data?.business?.business_description || 'N/A'])
  rows.push(['RUC:', data?.business?.ruc || 'N/A'])
  rows.push(['Dirección:', data?.business?.address || 'N/A'])
  rows.push(['Teléfono:', data?.business?.phone_number || 'N/A'])
  rows.push(['Usuario:', data?.user_full_name || 'N/A'])
  rows.push(['Código de usuario:', data?.user_uid || 'N/A'])
  rows.push([''])
  rows.push([''])

  // ====== RESUMEN ======

  rows.push(['RESUMEN TOTAL'])
  rows.push([''])
  rows.push(['Tipo de pago', 'Monto'])

  rows.push(['Efectivo', formatMoney(data?.cash_amount || 0)])
  rows.push(['Transferencia', formatMoney(data?.transference_amount || 0)])
  rows.push(['Pago digital', formatMoney(data?.payment_digital_amount || 0)])
  rows.push(['Depósito bancario', formatMoney(data?.deposit_amount || 0)])
  rows.push(['Cheque', formatMoney(data?.cheque_amount || 0)])
  rows.push(['Tarjeta de crédito', formatMoney(data?.credit_card_amount || 0)])
  rows.push(['Vale digital', formatMoney(data?.vale_digital_amount || 0)])
  rows.push(['Pago policía', formatMoney(data?.payment_amount || 0)])
  rows.push(['TOTAL COBRADO', formatMoney(data?.total_amount || 0)])
  rows.push([''])

  if (!data?.charge_uid || data?.charge_uid.length === 0) {
    rows.push(['TOTAL CRÉDITO', formatMoney(data?.delivery_credit_amount || 0)])
    rows.push([''])
  }

  // ====== DESGLOSE DE EFECTIVO ======

  rows.push([''])
  rows.push(['DESGLOSE DE EFECTIVO'])
  rows.push([''])
  rows.push(['DENOMINACIÓN', 'CANTIDAD'])

  if (data?.cash_count && data?.cash_count.denominations) {
    Object.entries(data?.cash_count.denominations).forEach(([denominacion, cantidad]) => {
      rows.push([denominacion, cantidad])
    })
  } else {
    rows.push(['N/A', 'N/A'])
  }

  // ====== DOCUMENTOS ASOCIADOS ======

  const headersReceived = [
    'FECHA', 'HORA', 'CÓDIGO', 'CLIENTE',
    'NÚMERO DE DOCUMENTO', 'TIPO DE DOCUMENTO',
    'REFERENCIA', 'FORMA PAGO',
    'SALDO', 'PAGADO'
  ]

  let receivedDetails = [
    ['DOCUMENTOS ASOCIADOS A ESTA LIQUIDACIÓN:'],
    [''],
    headersReceived
  ]

  data?.details.forEach((detail) => {
    let detailArrayReceived = [
      formatDate(detail.date_of_charge) || 'N/A',
      formatTime(detail.date_of_charge) || 'N/A',
      detail.client_uid || 'N/A',
      detail.client_name || 'N/A',
      detail.child_document_reference || 'N/A',
      parseDocumentType(detail.child_document_type) || 'N/A',
      detail.charge_uid ? detail.charge_uid : 'N/A',
      isDocumentCredit(detail) ? 'Crédito' : 'Contado',
      formatMoney(detail.child_document_balance || 0),
      formatMoney(isDocumentCredit(detail) ? 0.0 : detail.child_document_amount || 0)
    ]

    if (detail.charge_status === 'received' || detail.client_payment_type === 'credito') {
      receivedDetails.push(detailArrayReceived)
    }
  })

  rows.push([''])
  rows = rows.concat(receivedDetails)


  // ====== RESUMEN POR TIPO DE DOCUMENTO ======
  rows.push(['']);
  rows.push(['RESUMEN POR TIPO DE DOCUMENTO']);
  rows.push(['']);

  let resumenTipoDoc = {};

  data?.details.forEach(detail => {
    if (detail.charge_status !== "received" && detail.client_payment_type !== "credito") return;

    const tipo = parseDocumentType(detail.child_document_type) || 'N/A';

    const total = isDocumentCredit(detail)
      ? 0.0
      : Number(detail.child_document_amount || 0);

    if (!resumenTipoDoc[tipo]) resumenTipoDoc[tipo] = 0;
    resumenTipoDoc[tipo] += total;
  });

  rows.push(['TIPO DE DOCUMENTO', 'TOTAL']);

  if (Object.keys(resumenTipoDoc).length === 0) {
    rows.push(['N/A', 'N/A']);
  } else {
    Object.entries(resumenTipoDoc).forEach(([tipo, total]) => {
      rows.push([
        tipo,
        formatMoney(total)
      ]);
    });
  }

  // ====== DOCUMENTOS RECHAZADOS ======

  const headersRejected = [
    "FECHA", "HORA", "CÓDIGO", "CLIENTE",
    "NÚMERO DE DOCUMENTO", "NÚMERO DE RECHAZO",
    "TIPO DE DOCUMENTO", "MOTIVO RECHAZO", "TOTAL"
  ];

  let rejectedDetails = [
    ["DOCUMENTOS RECHAZADOS ASOCIADOS A ESTA LIQUIDACIÓN:"],
    [""],
    headersRejected
  ];

  let rawRejectedData = [];

  if (data?.refunds?.length > 0) {
    data.refunds.forEach(refund => {
      const motivo = (refund.refund_details?.[0]?.motive || refund.motive || "N/A")
        .trim()
        .replace(/\s{2,}/g, " ");

      const rawTotal = Number(refund.total || 0);

      rawRejectedData.push({ motivo, total: rawTotal });

      rejectedDetails.push([
        formatDate(refund.date_of_document),
        formatTime(refund.date_of_document),
        refund.client_db_ref || "N/A",
        refund.client_description || "N/A",
        refund.invoice_number || "N/A",
        refund.db_ref || "N/A",
        parseRefundType(refund.refund_type),
        motivo,
        formatMoney(rawTotal)
      ]);
    });
  } else {
    rejectedDetails.push(Array(headersRejected.length).fill("N/A"));
  }

  rows.push([""]);
  rows = rows.concat(rejectedDetails);

  // ====== RESUMEN MOTIVOS DE RECHAZO POR DOCUMENTO ======
  rows.push([""]);
  rows.push(["RESUMEN MOTIVOS DE RECHAZO POR DOCUMENTO"]);
  rows.push([""]);

  let resumenMotivoDocs = {};

  rawRejectedData.forEach(({ motivo, total }) => {
    if (!resumenMotivoDocs[motivo]) resumenMotivoDocs[motivo] = 0;
    resumenMotivoDocs[motivo] += total;
  });

  rows.push(["MOTIVO DE RECHAZO", "TOTAL"]);

  Object.entries(resumenMotivoDocs).forEach(([motivo, total]) => {
    rows.push([motivo, formatMoney(total)]);
  });


  // ====== PRODUCTOS RECHAZADOS ======

  const refundsReceived = [
    'NÚMERO DE FACTURA',
    'CÓDIGO DE PRODUCTO',
    'CÓDIGO DE BARRA',
    'NOMBRE DEL PRODUCTO',
    'MOTIVO DE RECHAZO',
    'UNIDAD DE VENTA',
    'CANTIDAD',
    'PRECIO',
    'TOTAL'
  ];

  let refundProductDetails = [
    ['PRODUCTOS RECHAZADOS ASOCIADOS A ESTA LIQUIDACIÓN:'],
    [''],
    refundsReceived
  ];

  if (data?.refunds && data.refunds.length > 0) {
    data.refunds.forEach(refund => {
      let refundReceiptHeader = [
        `${refund.invoice_number} | ${refund.client_db_ref} - ${refund.client_description}`,
        '', '', '', '', '', '',
        `ENLACE FACTURA: ${origin}/devoluciones/${refund.uuid}`,
        ''
      ];

      refundProductDetails.push(['']);
      refundProductDetails.push(refundReceiptHeader);
      refund.refund_details.forEach(detail => {
        let detailArray = [
          '',
          detail.product_db_ref || 'N/A',
          detail.product_barcode || 'N/A',
          detail.product_description || 'N/A',
          (detail.motive || refund.motive || 'N/A').trim().replace(/\s{2,}/g, ' '),
          detail.unit_of_sale || 'N/A',
          detail.quantity || 'N/A',
          formatMoney(detail.unit_price || 0.0),
          formatMoney(detail.extended_price || 0.0)
        ];

        refundProductDetails.push(detailArray);
      });
    });
  }

  rows.push(['']);
  rows = rows.concat(refundProductDetails);


  // ====== RESUMEN MOTIVOS DE PRODUCTOS RECHAZADOS ======
  rows.push(['']);
  rows.push(['RESUMEN MOTIVOS DE RECHAZO POR PRODUCTO']);
  rows.push(['']);

  let resumenMotivoProductos = {};

  if (data?.refunds && data.refunds.length > 0) {
    data.refunds.forEach(refund => {
      refund.refund_details.forEach(detail => {
        const motivo = (detail.motive || refund.motive || 'N/A').trim();
        const total = Number(detail.extended_price || 0);

        if (!resumenMotivoProductos[motivo]) resumenMotivoProductos[motivo] = 0;
        resumenMotivoProductos[motivo] += total;
      });
    });
  }

  rows.push(['MOTIVO DE RECHAZO', 'TOTAL']);

  Object.entries(resumenMotivoProductos).forEach(([motivo, total]) => {
    rows.push([motivo, formatMoney(total)]);
  });



  // ====== DOCUMENTOS ANULADOS ======

  const headersCancelled = [
    'FECHA', 'HORA', 'CÓDIGO', 'CLIENTE',
    'DOCUMENTO', 'TIPO DE DOCUMENTO',
    'ESTATUS', 'TOTAL'
  ]

  let cancelledDetails = [
    ['DOCUMENTOS ANULADOS ASOCIADOS A ESTA LIQUIDACIÓN:'],
    [''],
    headersCancelled
  ]

  data?.details.forEach((detail) => {
    if (detail.charge_status === 'cancelled' && canSeeAnnulledDocumentsTab) {
      let detailArrayCancelled = [
        formatDate(detail.date_of_charge) || 'N/A',
        formatTime(detail.date_of_charge) || 'N/A',
        detail.client_uid || 'N/A',
        detail.client_name || 'N/A',
        detail.child_document_reference || 'N/A',
        parseDocumentType(detail.child_document_type) || 'N/A',
        'Anulado',
        formatMoney(detail.child_document_total || 0)
      ]
      cancelledDetails.push(detailArrayCancelled)
    }
  })

  if (canSeeAnnulledDocumentsTab) {
    rows.push([''])
    rows = rows.concat(cancelledDetails)
  }

  return rows
}
